/**
 * Domain utility functions for multi-tenant salon application
 * Handles domain extraction and localhost detection
 */

/**
 * Get application domain from current URL
 * Handles localhost and various network environments
 * 
 * @returns {string} Domain name (e.g., "luxurybeauty.com")
 * 
 * @example
 * // Production: www.luxurybeauty.com → "luxurybeauty.com"
 * // Localhost: localhost:5173 → "luxurybeauty.com" (default)
 */
export const getAppDomain = (): string => {
  const url = window.location.href;
  const { hostname } = new URL(url);

  // Detect local development environments
  const isLocalhost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname);

  if (isLocalhost) {
    // Default domain for local development
    // Can be overridden via environment variable
    return import.meta.env.VITE_DEFAULT_DOMAIN || 'salon.snapmenu.ai';
  }

  // Remove 'www.' prefix if present
  return hostname.replace(/^www\./, '');
};
